import { Spinner } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function StorefrontLoading() {
  return (
    <main>
      <output {...stylex.props(styles.loading)}>
        <Spinner />
        Loading
      </output>
    </main>
  );
}
const styles = stylex.create({
  loading: {
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing.space12,
    color: colors.subtle,
    fontFamily: fonts.sans,
    fontSize: fontSizes.small,
  },
});
